import { render } from "./SubscriptionFAQ.vue?vue&type=template&id=2c80d833"
import script from "./SubscriptionFAQ.vue?vue&type=script&lang=ts"
export * from "./SubscriptionFAQ.vue?vue&type=script&lang=ts"
script.render = render

export default script